import React, { createContext, useContext, useState, useEffect } from 'react';
import { translations } from '../i18n/translations';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    // Get language from localStorage or default to Hebrew
    return localStorage.getItem('language') || 'he';
  });

  useEffect(() => {
    console.log('LanguageContext: Language changed to:', language);
    
    // Save to localStorage
    localStorage.setItem('language', language);
    
    // Update document direction
    const newDir = language === 'he' ? 'rtl' : 'ltr';
    document.documentElement.dir = newDir;
    document.documentElement.lang = language;
    
    // Update body direction
    document.body.dir = newDir;
    
    console.log('LanguageContext: Direction set to:', newDir);
  }, [language]);

  const toggleLanguage = () => {
    console.log('LanguageContext: toggleLanguage called, current language:', language);
    const newLang = language === 'he' ? 'en' : 'he';
    console.log('LanguageContext: Setting language to:', newLang);
    setLanguage(newLang);
  };

  const t = (key) => {
    const keys = key.split('.');
    let value = translations[language];
    
    for (const k of keys) {
      value = value?.[k];
    }
    
    // If value is undefined or null, try to find fallback from the other language
    if (value === undefined || value === null) {
      console.warn(`Translation missing for key: ${key} in language: ${language}`);
      const fallbackLang = language === 'he' ? 'en' : 'he';
      let fallbackValue = translations[fallbackLang];
      for (const k of keys) {
        fallbackValue = fallbackValue?.[k];
      }
      return fallbackValue || key;
    }
    
    return value;
  };

  return (
    <LanguageContext.Provider value={{ language, toggleLanguage, t, isRTL: language === 'he' }}>
      {children}
    </LanguageContext.Provider>
  );
};
